import "./Experience.scss";
import { useNavigate } from "react-router-dom";

const Experience = () => {
  const navigate = useNavigate();

  return (
    <div className="experience">
      <section>
        <div>
          <div id="xp">
            <h2>Plus de 35 ans d'expérience au service de nos clients</h2>
            <p>
              Depuis 1986, la société SP Hygiène conçoit et commercialise une
              large gamme de produits d'hygiène et d'entretien. <br />
              <br />
              Fort de notre expérience, nous pouvons aujourd'hui vous proposer,
              à travers nos 12 familles de produits, des solutions définies
              sur-mesure. Nous répondons à vos besoins quels que soient votre
              usage et votre domaine d'activité : entreprise de propreté et
              syndics, collectivités, établissements de santé, hôtellerie et
              restauration, etc.
            </p>
          </div>
          <div className="img-container">
            <div className="image-container">
              <img src="/images/experience-home.png" alt="experience" />
            </div>
          </div>
        </div>
        <div className="button-div">
          <button className="see-more" onClick={() => navigate("/about")}>
            En savoir plus
          </button>
        </div>
      </section>
    </div>
  );
};

export default Experience;
